import { useContext, useEffect } from 'react';
// @ts-ignore
import { ThemeContext } from '@qover/styles';
import { BaseDraft } from '@qover/domain';
import { MailCampaignService } from '@qover/services';
import { Path } from '../domain/Step';

export function useRemarketing<TDraft extends BaseDraft>(
  step: Path | undefined,
  draft: TDraft,
) {
  const theme = useContext<any>(ThemeContext);
  const remarketing = theme?.featureToggles?.track?.mailchimp?.remarketing;

  useEffect(() => {
    if (remarketing && step?.remarketing) {
      MailCampaignService.updateStep(draft, step.remarketing);
    }
  }, [step?.path, remarketing]);

  return null;
}
